import { Box } from '@chakra-ui/react';

import { FilterIcon } from 'Asset/icon';
import SearchComponent from 'UiKit/search';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextMedium } from 'UiKit/typography';
import { Condition, Iteration } from 'Component/others';
import { useUserInfo } from 'Store/userInfo';
import useGetBrand from 'Domain/brand/useGetBrand';
import { useFilterToggle } from 'View/host-stock-promo/helper/useFilterToggle';
import { useHostStockPromoState } from 'View/host-stock-promo/state';
import StockFilterDrawer from 'View/host-stock-promo/component/stock-filter-drawer';
import PromoFilterDrawer from 'View/host-stock-promo/component/promo-filter-drawer';
import FilterSkeleton from 'View/host-stock-promo/component/skeleton/filter-skeleton';

import styles from './styles.module.css';
import { useEffect } from 'react';

const Filter = () => {
  const { state, filterState, updateFilterState, updateState } = useHostStockPromoState();

  const { userBrand } = useUserInfo();

  const { data: brands, isLoading: isLoadingBrand } = useGetBrand();

  const { isActive: isBrandActive, toggleFilter: toggleBrand } = useFilterToggle(filterState?.brandId, updateFilterState, 'brandId');

  const onClose = () => {
    updateState({ stockFilterDrawerOpen: false, promoFilterDrawerOpen: false });
  };

  const handleFilterClick = () => {
    if (state?.selectedTab === 'stok') {
      updateState({ stockFilterDrawerOpen: true });
    } else {
      updateState({ promoFilterDrawerOpen: true });
    }
  };

  useEffect(() => {
    updateFilterState({ brandId: userBrand });
  }, [userBrand]); // eslint-disable-line

  return (
    <Condition statement={!isLoadingBrand} fallback={<FilterSkeleton />}>
      <Box className={styles['filter__container']} transform={state?.showTopBar ? 'translateY(0)' : 'translateY(-42px)'} data-testid="filter">
        <Box className={styles['filter__search-filter']}>
          <SearchComponent width="100%" height="28px" onSearch={(search) => updateFilterState({ search, page: 1 })} value={filterState?.search} />
          <ButtonOutline className={styles['filter__button']} onClick={() => handleFilterClick()}>
            <FilterIcon />
            <TextMedium className={styles['filter__button-text']}>Filter</TextMedium>
          </ButtonOutline>
        </Box>
        <Box className={styles['filter__brands']}>
          <Iteration
            items={brands}
            render={(item) => (
              <Box
                key={item?.id}
                className={`${styles['filter__brands-badge']} ${isBrandActive(item?.value) ? styles['filter__brands-badge--active'] : ''}`}
                onClick={() => toggleBrand(item?.value)}
              >
                {item?.value}
              </Box>
            )}
          />
        </Box>
      </Box>

      <StockFilterDrawer isOpen={state?.stockFilterDrawerOpen} onClose={onClose} />
      <PromoFilterDrawer isOpen={state?.promoFilterDrawerOpen} onClose={onClose} />
    </Condition>
  );
};

export default Filter;
